import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/Samurai.Sushi.teriyaki/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Samurai Sushi & Teriyaki Japanese Restaurant Facebook"
              />
            </CFLink>
            {/* <CFLink href="https://www.instagram.com/sahali_tongdak/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Samurai Sushi & Teriyaki Japanese Restaurant Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/Samurai.Sushi.teriyaki/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Samurai Sushi & Teriyaki Japanese Restaurant Facebook"
              />
            </CFLink>
            {/* <CFLink href="https://www.instagram.com/sahali_tongdak/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Samurai Sushi & Teriyaki Japanese Restaurant Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
